<template>
    <div>
        <Header />
        <BannerGalery />
        <section class="furniture_area p_120" id="dlealp_section_projects">
            
            <div class="container">

                <div class="main_title" style="margin-bottom: 20px;">
                    <h2>Veja alguns dos trabalhos executados pela Dlealp</h2>
                    <p>
                        Para visualizar o conteúdo por projeto executado, utilize o filtro. 
                    </p>
                </div>

                <hr>

                <div class="checkboxes_dl text-center">
                    <p><strong>Selecione o projeto</strong></p>
                    <div>
                        <span v-for="(project, index) in projects">
                            <input type="checkbox" name="choice" :id="`${index}dl`" v-model="selectedProjects" :value="project.id" @change="changeProject()"/>
                                <label :for="`${index}dl`">{{project.name}}</label>
                        </span>
                    </div>
                </div>


                <div class="checkboxes_dl text-center">
                    <p><strong>Selecione uma categoria</strong></p>
                    <div>
                        <span v-for="(category, index) in categories">
                            <input type="checkbox" :id="`${index}cdl`" v-model="selectedCategories" :value="category.id" @change="changeCategory()"/>
                                <label :for="`${index}cdl`">{{category.name}}</label>
                        </span>
                    </div>
                </div>

                <br/> 
                    
                <hr>
             
                <div class="furniture_inner row">

                    <div class="col-lg-4 text-center" v-for="image in images">
                        <div class="furniture_item">
                            <a :href="retunLinkImage(image.link)" data-fancybox="gallery" :data-caption="image.name">
                                <img :src="retunLinkImage(image.link)" :alt="image.name" style="max-height: 240px;">
                            </a>
                            <h4>{{image.name}}</h4>
                            <div>
                                <span v-for="category in image.imageCategory">
                                    {{category.name}}
                                </span>
                            </div>
                        </div>
                    </div>
                    
                </div>

                <div class="row wrap_pagination">
                    <div class="col-lg-12 pagination">
                        <nav aria-label="...">
                            <ul class="pagination">
                                <li v-if="itens.current_page == 1" class="page-item disabled">
                                    <a href="#" class="page-link"> Retornar </a>
                                </li>
                                <li v-if="itens.current_page > 1" class="page-item">
                                    <a href="#" @click="goToPage(itens.prev_page_url)" class="page-link"> Retornar </a>
                                </li>

                                <li class="page-item disabled"><a href="#" class="page-link">Página</a></li>
                                <li class="page-item disabled"><a href="#" class="page-link">{{itens.current_page}}</a></li>
                                <li class="page-item disabled"><a href="#" class="page-link">de</a></li>
                                <li class="page-item disabled"><a href="#" class="page-link">{{itens.last_page}}</a></li>
                                
                                <li v-if="itens.current_page == itens.last_page" class="page-item disabled">
                                    <a href="#" class="page-link"> Avançar </a>
                                </li>

                                <li v-if="itens.current_page < itens.last_page" class="page-item">
                                    <a href="#" @click="goToPage(itens.next_page_url)" class="page-link"> Avançar </a>
                                </li>

                            </ul>
                        </nav>
                    </div>
                </div>  
            
               
            </div>

        </section>
        <Clients />
        <Footer />
    </div>
</template>
<script>
    import axios from 'axios';
    import SmoothScroll from 'smooth-scroll';
    import Header from '../components/header';
    import BannerGalery from '../components/banner_galery';
    import $ from 'jquery';

    import Clients from '../components/clients';
    import Footer from '../components/footer';
    import {apiURL} from '../resources/apiUrl';
    
    let axiosInstance = axios.create();

    export default {
        
        name: 'galeria',

        data: function () {
            return {
                itens: {
                    total: 0,
                    per_page: 0,
                    current_page: 0,
                    last_page: 0,
                    next_page_url: null,
                    prev_page_url: null,
                    data: []
                },
                images: [],
                projects: [],
                selectedProjects: [],
                categories: [],
                selectedCategories: [],
            }
        },
        
        components: {
            Header,
            BannerGalery,
            Clients,
            Footer
        },

        created() {
            this.getListOfProjects();
        },

        mounted() {

            let nav_offset_top = $('header').height() + 50;
            
            if ( $('.header_area').length ){ 
                $(window).scroll(function() {
                    var scroll = $(window).scrollTop();   
                    if (scroll >= nav_offset_top ) {
                        $(".header_area").addClass("navbar_fixed");
                    } else {
                        $(".header_area").removeClass("navbar_fixed");
                    }
                })
            }
            
            let scroll = new SmoothScroll('a[href*="#"]');
            
            $('.nav a').on('click', function(){
                $('.navbar-toggler').click();
            });

            $('[data-fancybox="gallery"]').fancybox({
                // Options will go here
            });

        },

        methods: {

            changeProject(){
                if( this.selectedProjects.length <= 0 ) {
                    alert("Selecione pelo menos um projeto");
                }else{
                    this.goToPage(`${apiURL()}/lp/images?per_page=15&page=${this.itens.current_page}`);
                }
            },

            changeCategory(){
                if( this.selectedCategories.length <= 0 ) {
                    alert("Selecione pelo menos uma categoria");
                }else{
                    this.goToPage(`${apiURL()}/lp/images?per_page=15&page=${this.itens.current_page}`);
                }
            },

            getListOfCategories(){
                axiosInstance.get(`${apiURL()}/lp/category/list`)
                .then(response => {
                    this.categories = response.data;
                    this.categories.forEach(element => {

                        if( this.$route.params.tipo != undefined ){
                        
                            if( element.name == this.$route.params.tipo){
                                this.selectedCategories.push(element.id);
                            }

                        } else {
                                this.selectedCategories.push(element.id);
                        }
                    
                    });
                    this.goToPage(`${apiURL()}/lp/images?per_page=15&page=1`);
                })
                .catch(error => {
                    console.log(error);
                })
            },

            getListOfProjects(){
                axiosInstance.get(`${apiURL()}/lp/project/list`)
                .then(response => {
                    this.projects = response.data;
                    this.projects.forEach(element => {
                        this.selectedProjects.push(element.id);
                    });
                    this.getListOfCategories();
                })
                .catch(error => {
                    console.log(error);
                })
            },

            returnArrayToListWithComma(arrayList){
                return arrayList.join(", ");
            },

            retunLinkImage(linkImage){
                return `${apiURL()}/lp/images/${linkImage}`;
            },

            goToPage(uri){
                this.$store.commit('changeLoading')
                let url = `${uri}&projects=${this.returnArrayToListWithComma(this.selectedProjects)}&categories=${this.returnArrayToListWithComma(this.selectedCategories)}`;
                axiosInstance.get(url)
                    .then(response => {
                        this.itens = response.data;
                        this.images = response.data.data;
                        this.$store.commit('changeLoading')
                    })
                    .catch(error => {
                        console.log(error);
                    })
            }

        }
    }
</script>

<style>

    .checkboxes_dl label {
    padding: 4px 6px;
    line-height: 190%;
    outline-style: none;
    transition: all .2s;
    margin-right: 2px;
    }

    .checkboxes_dl div {
    display: inline;
    margin: 0;
    padding: 0;
    list-style: none;
    }

    .checkboxes_dl input[type="checkbox"],
    .checkboxes_dl input[type="radio"] {
    display: none;
    
    }

    .checkboxes_dl label {
    cursor: pointer;
    }

    .checkboxes_dl input[type="checkbox"]+label:hover{
    background: #faba00;
    }

    .checkboxes_dl input[type="checkbox"]:checked+label {
    background: #faba00;
    color: aliceblue;
    }

    .checkboxes_dl input[type="checkbox"]:checked+label:hover{
    background: #faba00;
    }

</style>